module.exports = {"missingPermission":"Lo sentimos. En este momento, no tienes acceso a esta página.","contactAdministration":"Ponte en contacto con la persona de tu empresa encargada de administrar esta Cuenta de Trustpilot."}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/MissingPermission/localization/es-ES/strings.json
// module id = 1228
// module chunks = 0